import { useState } from "react";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Grid, Stack } from "@mui/system";
import DoneIcon from "@mui/icons-material/Done";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";

const CreateCollectionTypesModal = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [collectionTypeName, setCollectionTypeName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const handleInputChange = (value: any) => {
    setCollectionTypeName(value.replace(/[^a-zA-Z0-9_ ]/g, "")); // Removes special characters

    const regex = /^[a-zA-Z][a-zA-Z0-9_]*(?: [a-zA-Z0-9_]+)*[^ _]$/;
    // Check if at least 3 letters exist
    const letterCount = (value.match(/[a-zA-Z]/g) || []).length;

    if (!regex.test(value) || letterCount < 3) {
      setError(
        "Only letters, numbers, single spaces, and underscores allowed. Must start with a letter and cannot end with a space or underscore."
      );
    } else {
      setError("");
    }
  };

  //-- Clicking on create new Collection type
  const CreateNewCollectionType = async () => {
    const data = {
      collection_type_name: collectionTypeName,
    };
    try {
      setLoading(true);
      if (oauthTokenHeader) {
        await MetaEntitiesEndPointLogic.createMetaCollectionType(
          oauthTokenHeader,
          data
        );
        await MetaEntitiesEndPointLogic.getMetaCollectionType(
          oauthTokenHeader,
          dispatch
        );
      } else {
        throw new Error(
          "User doesn't have permissions to create new collection types"
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      handleCancel();
    }
  };

  // -- Cancel
  const handleCancel = () => {
    handleClose();
    setCollectionTypeName(null);
  };

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Create New Collection Type
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid size={12}>
                <TextField
                  value={collectionTypeName}
                  onChange={(e: any) => handleInputChange(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Collection Type *" // Set your label here
                  placeholder="Enter unique Collection Type Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                  required
                  error={!!error}
                  helperText={error}
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              This is a mandatory field.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleCancel} sx={{ mr: 1 }}>
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!collectionTypeName || error}
                onClick={CreateNewCollectionType}
                data-tracker="237"
              >
                Create <DoneIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
};

export default CreateCollectionTypesModal;
